import React, {Fragment} from 'react';
import blockStyles from '@baseStyles/block.scss';
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import Button from "@components/base/Button/Button";
import useDataFileAction from "@hooks/useDataFileAction";

const ContentA2 = ({data, columns = 1, color = ''}) => {

	if (!data) {
		return null;
	}

	const {executeAction, ModalPortal} = useDataFileAction({color: color});

	const columnsMap = {
		1: '',
		2: blockStyles.twoColumns,
		3: blockStyles.threeColumns
	}
	const columnsClass = columnsMap[columns];

	const blockTitle = data.blockTitle;
	const blockDesc = data.blockDesc;
	const contentTop = data.blockContent.top;
	const contentBottom = data.blockContent.bottom;

	return (
	  <div className={blockStyles.baseContainerHolder}>
		  {/* INTRO CONTAINER */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  <ContentB1 title={blockTitle} desc={blockDesc}/>

		  {data.buttonText &&
			<div className={'baseMarginBottom tcenter'}>
				{/* Button */}
				<Button
				  value={data.buttonText}
				  onClick={() => executeAction(data)}
				/>
			</div>
		  }

		  <div className={`${blockStyles.baseContainer} ${color ? blockStyles[color] : ''}`}>
			  <div className={`${blockStyles.columnContainer} ${blockStyles.oneColumn}`}>

				  {/* TOP COLUMN CONTENT */}
				  {/*///////////////////////////////////////////////////////////////////////////////*/}
				  <div className={`${blockStyles.textBox} ${contentTop.gap ? blockStyles[contentTop.gap] : ''}`}>
					  {contentTop.content && contentTop.content.map((item, key) => {
						  return (
							<Fragment key={key}>
								{/* Title */}
								{item.title &&
								  <h2
									className={blockStyles.h3}
									dangerouslySetInnerHTML={{__html: item.title}}
								  />
								}

								{/* Text */}
								{item.text &&
								  <div
									className={blockStyles.p}
									dangerouslySetInnerHTML={{__html: item.text}}>
								  </div>
								}

								{/* Button */}
								{item.buttonText &&
								  <Button
									value={item.buttonText}
									onClick={() => executeAction(item)}
								  />
								}
							</Fragment>
						  );
					  })}
				  </div>

				  {/* BOTTOM COLUMN CONTENT */}
				  {/*///////////////////////////////////////////////////////////////////////////////*/}
				  <div className={`${blockStyles.gridContainer} ${columnsClass} listStyleDiscOutSide`}>
					  {contentBottom.content && contentBottom.content.map((item, key) => {
						  return (
							<div
							  className={`${blockStyles.textBox} ${contentBottom.gap ? blockStyles[contentBottom.gap] : ''}`}
							  key={key}>
								{/* Title */}
								{item.title &&
								  <h3
									className={blockStyles.h4}
									dangerouslySetInnerHTML={{__html: item.title}}
								  />
								}

								{/* Subtitle */}
								{item.subtitle &&
								  <div
									className={`${blockStyles.p} ${blockStyles['color-gray-500']}`}
									dangerouslySetInnerHTML={{__html: item.subtitle}}>
								  </div>
								}

								{/* Description */}
								{item.description &&
								  <div
									className={blockStyles.p}
									dangerouslySetInnerHTML={{__html: item.description}}>
								  </div>
								}

								{/* Button */}
								{item.buttonText &&
								  <Button
									value={item.buttonText}
									onClick={() => executeAction(item)}
								  />
								}
							</div>
						  );
					  })}
				  </div>
				  {/*///////////////////////////////////////////////////////////////////////////////*/}

			  </div>
		  </div>

		  {/* Render modal with portal (in html.php container - <div id="modalContainer"></div>) */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  {ModalPortal}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
	  </div>
	)
}

export default ContentA2;
